import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import UploadAsset from "./UploadAsset";
import BasicDetails from "./BasicDetails";
import Assessment from "./Assessment";
import apiClient from "../../../apiClient";
import { XR_MODULE_DETAIL } from "../../../apiClient/apiEndpoints";

const Details = () => {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState("assessment");
  const [moduleData, setModuleData] = useState({});
  const navigator = useNavigate();
  const params = useParams();
  const uuid = params.id;
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);

  const handleChangeTab = (k) => {
    if (k === "back") {
      navigate("/dashboard/xr");
    } else {
      setActiveKey(k);
    }
  };

  const getModuleDetail = async () => {
    const moduleData = await apiClient.get(`${configData.config.UNO_URL}${XR_MODULE_DETAIL}/${uuid}`);
    setModuleData(moduleData);
  };

  useEffect(() => {
    getModuleDetail();
  }, [uuid]);

  return (
    <>
      <div className="filterhere">
        <Tabs activeKey={activeKey} onSelect={(k) => handleChangeTab(k)}>
          <Tab
            eventKey="back"
            title={
              <span>
                {" "}
                <i className="bi-chevron-left"></i> Back{" "}
              </span>
            }
          />

          {/* <Tab eventKey="details" title="Details" >
              <BasicDetails />
          </Tab>

          <Tab eventKey="assets" title="Upload Assets" >
              <UploadAsset />
          </Tab> */}

          <Tab eventKey="assessment" title="Assessment">
            <Assessment moduleData={moduleData} />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default Details;
